import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';

export const textBibleRoute: RouteRecordRaw = {
  path: '/text-bible',
  name: AppScreens.TextBible,
  meta: {
    layout: 'empty',
  },
  component: () => import('@/modules/text-bible/views/TextBibleReader.vue'),
};
